import { html } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";
import { getDummyText } from "../../../../utils";

interface TemplateArgs {
    className?: string;
    chapter?: string;
    separator?: boolean;
    tags?: string;
    tagsLabel?: string;
    title?: string;
    subtitle?: string;
}

export const Template = ({
    className,
    chapter,
    separator,
    tags,
    tagsLabel,
    title,
    subtitle,
}: TemplateArgs) => html`
    <ux-iws-nb-chapter-intro
        class=${ifDefined(className)}
        chapter=${ifDefined(chapter)}
        ?separator=${ifDefined(separator)}
        tags=${ifDefined(tags)}
        tags-label=${ifDefined(tagsLabel)}
    >
        <h2 slot="title">${title}</h2>
        <div slot="subtitle">${subtitle}</div>
        <div slot="description">${getDummyText(262)}</div>
    </ux-iws-nb-chapter-intro>
`;

export const templateArgs = {
    title: "Die TRUMPF All-in-One solution",
    subtitle: "– Höchste Präzision, ein Hersteller, null Kompromisse",
    tags: "Schweissen,Schneiden,Markieren",
    tagsLabel: "Unterstützte Anwendungen",
    chapter: "TruFiber S",
    separator: true,
};
